import { Alert as OriginAlert, IAlertProps } from './Alert';
import { ErrorBoundary } from './ErrorBoundary';

export type AlertProps = typeof OriginAlert & {
  ErrorBoundary: typeof ErrorBoundary;
};

const Alert = OriginAlert as AlertProps;

Alert.ErrorBoundary = ErrorBoundary;

export type { IAlertProps };
export { Alert };
